import LocationPageTemplate from '../components/LocationPageTemplate';
export default function BaltimorePage() { return <LocationPageTemplate locationSlug="baltimore" />; }
